import { useEffect, useState } from "react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api/trade-network/partner`;
const KINDS = {
  agreement: { get: "agreement", post: "sign-agreement", title: "Master Trade Agreement", tid: "partner-agreement" },
  release: { get: "release", post: "sign-release", title: "Independent Contractor Release & Hold Harmless", tid: "partner-release" },
};

export const AgreementCard = ({ p, kind = "agreement", onSigned }) => {
  const k = KINDS[kind];
  const [a, setA] = useState(null);
  const [name, setName] = useState(p.contact_name || "");
  const [title, setTitle] = useState("Owner");
  const [agree, setAgree] = useState(false);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const load = () => fetch(`${API}/${p.partner_id}/${k.get}`).then((r) => r.json()).then(setA).catch(() => setErr("Could not load the document"));
  useEffect(() => { load(); }, [p.partner_id, kind]); // eslint-disable-line react-hooks/exhaustive-deps
  const sign = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    const r = await fetch(`${API}/${p.partner_id}/${k.post}`, { method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ signed_name: name, title, agree }) });
    const j = await r.json().catch(() => ({}));
    setBusy(false);
    if (r.ok) { load(); onSigned && onSigned(); } else setErr(j.detail || "Could not sign");
  };
  if (!a) return null;
  return (
    <div className={`pw-card ${a.signed ? "pw-card--ok" : ""}`} data-testid={k.tid}>
      <h2 className="pw-h2">{k.title}</h2>
      {a.signed ? (
        <p className="pw-p" data-testid={`${k.tid}-signed`}>Signed by <b>{a.signature.signed_name}</b> on {new Date(a.signature.signed_at).toLocaleString()} · signature {a.signature.signature_sha256.slice(0, 12)}…</p>
      ) : (
        <form onSubmit={sign} data-testid={`${k.tid}-form`}>
          <div className="pw-agreement" data-testid={`${k.tid}-text`}>
            {a.sections.map((s) => <div key={s.heading}><b>{s.heading}</b><p>{s.body}</p></div>)}
          </div>
          <label className="pw-p">Full legal name<input className="pw-input" value={name} onChange={(e) => setName(e.target.value)} data-testid={`${k.tid}-name`} /></label>
          <label className="pw-p">Title<input className="pw-input" value={title} onChange={(e) => setTitle(e.target.value)} data-testid={`${k.tid}-title`} /></label>
          <label className="pw-check"><input type="checkbox" checked={agree} onChange={(e) => setAgree(e.target.checked)} data-testid={`${k.tid}-agree`} /> I have read and agree to sign this document electronically.</label>
          {err && <div className="pw-err" data-testid={`${k.tid}-error`}>{err}</div>}
          <button className="pw-btn" disabled={busy || !agree || name.trim().length < 3} data-testid={`${k.tid}-sign`}>{busy ? "Signing…" : "Sign"}</button>
          <p className="pw-p pw-muted">Version {a.version} · document SHA-256 {a.sha256.slice(0, 16)}…</p>
        </form>
      )}
    </div>
  );
};

export const ReadinessCard = ({ p }) => {
  const r = p.readiness;
  if (!r) return null;
  return (
    <div className="pw-card" data-testid="partner-readiness">
      <h2 className="pw-h2">{r.work_ready ? "You're cleared for work orders" : "Before your first work order"}</h2>
      <p className="pw-p">Partner tier: <b data-testid="partner-tier">{r.tier === "independent" ? "Independent operator (low-risk scopes: cleaning, trash-out, painting, detailing)" : "Commercial insured (full trade eligibility)"}</b></p>
      {!r.work_ready && <ul className="pw-terms" data-testid="partner-missing">{r.missing.map((m) => <li key={m}>{m}</li>)}</ul>}
      <p className="pw-p pw-muted">Our executive leadership calls every new partner personally before the first dispatch. Work runs 06:00–18:00 in the platform's turn sequence.</p>
    </div>
  );
};
